import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/blog/farmacovigilancia/*")({
  head: () => buildRouteHead("/blog/farmacovigilancia/*", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/blog", replace: true });
  },
});
